// import $ from "jquery";
import CONFIG from "@bd-core/config";

export default class Timer {
    constructor(timeoutCallback) {
        this.timeoutCursor = null;
        this.timeoutCallback = timeoutCallback;
        this.elms = {};
    }

    init() {
        // Don't run this on static page
        if (!CONFIG.game.timeLimit) return false;

        let self = this;

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
        }

        const getCurrentTime = () => new Date(Date.now()).getTime();
        const timeLimit = new Date(
            getCurrentTime() + CONFIG.game.timeLeft * 1000,
        );

        const timeLeft = timeLimit.getTime() - getCurrentTime();


        if (timeLeft <= 0 || CONFIG.game.isFinish) {
            return false;
        }

        this.timeoutCursor = setInterval(() => {
            const time = timeLimit.getTime() - getCurrentTime();

            if (time <= 0) {
                if (self.timeoutCursor) {
                    clearInterval(self.timeoutCursor);
                }

                if (typeof self.timeoutCallback == "function")
                    self.timeoutCallback();
            }
        }, 1000);

        return this;
    }

    stopTimer() {
        if (CONFIG.game.isFinish) {
            clearInterval(this.timeoutCursor);
        }
    }
}
